import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '../components/core_link';
import { RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { ArrowRightIcon } from '@reverbdotcom/cadence/icons/react';
import { CTA } from '../elog/mparticle_tracker';

interface Props {
  href: string;
  text?: string;
  'aria-describedby'?: string;
}

export function OverflowingRowAction(props: Props) {
  return (
    <CoreLink
      className="overflowing-row-action"
      to={props.href}
      interactionType={CTA}
      aria-describedby={props['aria-describedby']}
    >
      <div className="overflowing-row-action__text-with-icon">
        <RCTextWithIcon svgComponent={ArrowRightIcon} placement="right">
          {props.text
            ? props.text
            : I18n.t('commons.seeMore')}
        </RCTextWithIcon>
      </div>
      <div className="overflowing-row-action__icon">
        <ArrowRightIcon />
      </div>
    </CoreLink>
  );
}
